import { HsOutputMessageObject } from './output-message-object.class';
import { HsOutputMessageType } from './output-message-type.enum';

/**
 * Handles s error message.
 */
export class HsErrorMessage extends HsOutputMessageObject {
  constructor(public readonly message: string) {
    super(HsOutputMessageType.Error);
  }
}
